import { useEffect } from "react";
import { useLocation } from "wouter";
import { AdminSidebar } from "@/components/admin/sidebar";
import { AdminPageHeader } from "@/components/admin/admin-page-header";
import { AdminPropertySwitcher } from "@/components/admin/property-switcher";
import { ADMIN_STYLES } from "@/lib/admin-styles";

export function AdminShellTheme() {
  const [location] = useLocation();
  useEffect(() => {
    document.documentElement.classList.toggle("admin-shell", location.startsWith("/admin"));
  }, [location]);
  return null;
}

interface AdminLayoutProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  headingId?: string;
  children: React.ReactNode;
}

export function AdminLayout({
  title,
  subtitle,
  actions,
  headingId,
  children,
}: AdminLayoutProps) {
  const id = headingId ?? "page-heading";

  return (
    <div className={ADMIN_STYLES.pageWrapper}>
      {/*
        The public site has had a skip link since launch; the admin panel had the
        target and not the link. Sixteen sidebar items stand between the top of
        every admin page and its content, so a keyboard user was tabbing through
        the whole navigation again on each screen.
      */}
      <a href="#main-content" className="skip-link" data-testid="admin-skip-to-main">
        Skip to main content
      </a>
      <AdminSidebar />
      <main
        id="main-content"
        className={ADMIN_STYLES.main}
        tabIndex={-1}
        aria-labelledby={title ? id : undefined}
      >
        <div className="mb-4">
          <AdminPropertySwitcher />
        </div>
        {title && (
          <AdminPageHeader
            id={id}
            title={title}
            subtitle={subtitle}
            actions={actions}
          />
        )}
        {children}
      </main>
    </div>
  );
}
